var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"font-weight-bolder text-nowrap",attrs:{"variant":_vm.row.IsUpToDate ? 'success' : 'danger'}},[_vm._v(" "+_vm._s(_vm.row.IsUpToDate ? 'Güncel' : 'Güncel Değil')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }